class QuickAddProduct extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.variantButtons = this.querySelectorAll('.shoppable-item-variant-selector');
    this.variantSelect = this.querySelector('[data-variant-select]');
    this.submitButton = this.querySelector('.shoppable-item-atc');
    this.hiddenInput = this.querySelector('.product-variant-id');
    this.buttonText = this.submitButton.querySelector('span');
    this.originalButtonText = this.buttonText.textContent;
    this.errorMessage = this.querySelector('#shoppable-item__err_msg');
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.variantButtons.forEach(button => {
      button.addEventListener('click', this.onVariantSelect.bind(this));
    });

    if (this.variantSelect) {
      this.variantSelect.addEventListener('change', this.onVariantSelectChange.bind(this));
    }

    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  clearError() {
    const variantContainer = this.querySelector('.shoppable-item-variants');
    if (variantContainer) {
      variantContainer.classList.remove('error');
    }
    if (this.variantSelect) {
      this.variantSelect.classList.remove('error');
    }
    if (this.errorMessage) {
      this.errorMessage.style.display = 'none';
    }
  }

  onVariantSelect(e) {

    const button = e.target.closest('.shoppable-item-variant-selector');
    if (!button || button.disabled) return;

    const variantId = button.dataset.variantId;


    this.hiddenInput.value = variantId;


    this.variantButtons.forEach(btn => btn.classList.remove('selected'));
    button.classList.add('selected');


    if (this.variantSelect) {
      this.variantSelect.value = variantId;
    }

    // Clear any error state
    this.clearError();

    // Update button text to show it's ready
    this.buttonText.textContent = this.originalButtonText;
  }

  onVariantSelectChange(e) {
    const variantId = e.target.value;

    if (!variantId) return;

    this.hiddenInput.value = variantId;
    this.variantButtons.forEach(btn => {
      btn.classList.remove('selected');
      if (btn.dataset.variantId === variantId) {
        btn.classList.add('selected');
      }
    });

    // Clear any error state
    this.clearError();

    // Update button text to show it's ready
    this.buttonText.textContent = this.originalButtonText;
  }

  onSubmit(e) {
    e.preventDefault();

    // Check if a variant is selected
    if (!this.hiddenInput.value || this.hiddenInput.value === '') {
      this.showVariantError();
      return;
    }

    this.addToCart();
  }

  showVariantError() {
    const variantContainer = this.querySelector('.shoppable-item-variants');
    if (variantContainer) {
      variantContainer.classList.add('error');
    }

    if (this.variantSelect) {
      this.variantSelect.classList.add('error');
    }

    if (this.errorMessage) {
      this.errorMessage.style.display = 'block';
    }

    this.buttonText.textContent = 'Please select a size';

    // Auto-hide error after 3 seconds
    setTimeout(() => {
      if (variantContainer) {
        variantContainer.classList.remove('error');
      }
      if (this.variantSelect) {
        this.variantSelect.classList.remove('error');
      }
      if (this.errorMessage) {
        this.errorMessage.style.display = 'none';
      }
      this.buttonText.textContent = this.originalButtonText;
    }, 3000);
  }

  addToCart() {
    const cartNotification = document.querySelector('cart-notification');

    this.submitButton.classList.add('loading');
    this.submitButton.setAttribute('aria-disabled', true);
    this.buttonText.textContent = 'Adding...';

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', this.hiddenInput.value);
    formData.append('quantity', '1');
    formData.append('sections', cartNotification?.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);

    config.body = formData;

    fetch(`${window.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error('Add to cart error:', response.status);
          this.buttonText.textContent = 'Error';
          return;
        }

        // Use the same cart notification as main product
        if (cartNotification) {
          cartNotification.renderContents(response);
        }

        // Fetch cart and dispatch event
        return fetch('/cart.json').then(res => res.json());
      })
      .then((cartData) => {
        if (cartData) {
          // Update cart counters like in cart.js before opening mini cart
          const cartBubble = document.querySelector('.ba-cart__bubble span');
          const miniCartItemCounter = document.querySelector('#mini-cart .ba-cart__title span');
          const miniCartRecommendations = document.querySelectorAll('#cart-product-recommendations');

          function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
          }

          // Update UI elements
          document.querySelector('cart-items')?.classList.toggle('is-empty', cartData.item_count === 0);
          document.getElementById('main-cart-items')?.classList.toggle('is-empty', cartData.item_count === 0);
          document.getElementById('main-cart-footer')?.classList.toggle('is-empty', cartData.item_count === 0);

          if (miniCartRecommendations?.length) miniCartRecommendations.forEach((el) => el.classList.toggle('hidden', cartData.item_count === 0));

          if (cartBubble) {
            cartBubble.textContent = pad(cartData.item_count, 2);
          }

          if (miniCartItemCounter) {
            miniCartItemCounter.textContent = cartData.item_count == 0 ? '' : `(${cartData.item_count})`;
          }

          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));

          if (window.gift_with_purchase?.available) {
            document.querySelector('cart-items')?.addOrRemoveGiftToCart(cartData);
          }

          // Update cart product recommendations like product-form.js does
          let recsContainer = document.querySelector('#cart-product-recommendations');
          let recsCardsContainer = document.querySelector('#cart-product-recommendations #slider--cart');
          if (recsContainer && recsCardsContainer && typeof addRecommendationsToMiniCart === 'function') {
            // Get product ID - variant IDs can be just numbers or have format like "product_id:variant_id"
            const productId = this.hiddenInput.value.toString().includes(':')
              ? this.hiddenInput.value.split(':')[0]
              : cartData.items?.find(item => item.variant_id == this.hiddenInput.value)?.product_id;

            if (productId) {
              recsContainer.setAttribute('product-id', productId);
              let url = recsContainer.dataset.url + productId;

              // Wrap the recommendations call to handle errors gracefully
              try {
                addRecommendationsToMiniCart(recsContainer, recsCardsContainer, url);
              } catch (error) {
                console.warn('Product recommendations failed to load:', error);
                // Don't let recommendations errors break cart functionality
              }
            }
          }
        }

        // Open mini cart AFTER all updates are complete
        this.openMiniCart();
      })
      .catch((e) => {
        console.error('Add to cart error:', e);
        this.buttonText.textContent = 'Error';
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.buttonText.textContent = this.originalButtonText;
        }, 1000);
      });
  }

  openMiniCart() {
    document.body?.classList.add('overflow-hidden');
    const miniCart = document.querySelector('#mini-cart');
    if (miniCart) {
      miniCart.classList.add('mini-cart--open');
      if (typeof trapFocus === 'function') {
        trapFocus(miniCart, miniCart.querySelector('.mini-cart__close'));
      }
      document.querySelector('.mini-cart-overlay')?.classList.add('mini-cart-overlay--open');
    }
  }
}

customElements.define('quick-add-product', QuickAddProduct);
class ProductCardOverlayManager {
  static DESKTOP_BREAKPOINT = 1279;
  static OVERLAY_Z_INDEX = 2;
  static activeOverlay = null;
  static originalCard = null;

  static clearErrorForElement(element) {
    const variantContainer = element.querySelector('.shoppable-item-variants');
    if (variantContainer) {
      variantContainer.classList.remove('error');
    }
    const variantSelect = element.querySelector('[data-variant-select]');
    if (variantSelect) {
      variantSelect.classList.remove('error');
    }
    const errorMessage = element.querySelector('#shoppable-item__err_msg');
    if (errorMessage) {
      errorMessage.style.display = 'none';
    }
  }

  static init(card) {
    if (!this.isDesktop()) return;

    this.cleanup();
    this.createOverlay(card);
  }

  static isDesktop() {
    return window.innerWidth >= this.DESKTOP_BREAKPOINT;
  }

  static createOverlay(originalCard) {
    this.originalCard = originalCard;
    this.activeOverlay = this.cloneCard(originalCard);

    // Hide horizontal overflow on body when hovering
    document.body.style.overflowX = 'hidden';

    // Make overflow visible on .new-product-recommendations when hovering
    const productRecommendations = document.querySelector('.new-product-recommendations');
    if (productRecommendations) {
      // Store original overflow value to restore later
      this.originalOverflow = productRecommendations.style.overflow || '';
      productRecommendations.style.overflow = 'visible';
    }

    // Ensure parent has relative positioning and high z-index
    if (originalCard.parentElement) {
      const parentPosition = window.getComputedStyle(originalCard.parentElement).position;
      if (parentPosition === 'static') {
        originalCard.parentElement.style.position = 'relative';
      }
      // Set high z-index on parent to ensure overlay appears on top
      originalCard.parentElement.style.zIndex = '1';
    }

    this.setupOverlayStyles(originalCard);
    this.initializeOverlayFunctionality();
    this.attachEventListeners();

    // Append to the card's parent container instead of body
    originalCard.parentElement.appendChild(this.activeOverlay);
  }

  static cloneCard(card) {
    const clone = card.cloneNode(true);

    clone.removeAttribute('onmouseenter');
    clone.classList.add('product-card-overlay');

    return clone;
  }

  static setupOverlayStyles(originalCard) {
    const rect = originalCard.getBoundingClientRect();
    const parentRect = originalCard.parentElement.getBoundingClientRect();

    // Calculate position relative to parent container
    const relativeTop = rect.top - parentRect.top;
    const relativeLeft = rect.left - parentRect.left;

    Object.assign(this.activeOverlay.style, {
      position: 'absolute',
      top: `${originalCard.offsetTop}px`,
      left: `${originalCard.offsetLeft}px`,
      width: `${rect.width}px`,
      height: 'auto',
      zIndex: this.OVERLAY_Z_INDEX,
      pointerEvents: 'auto',
       boxShadow: '0 4px 20px rgba(0,0,0,0.15)'
    });

    const shoppableForm = this.activeOverlay.querySelector('.shoppable-quick-add');
    if (shoppableForm) {
      shoppableForm.style.display = 'flex';
    }
  }

  static initializeOverlayFunctionality() {
    const quickAddElement = this.activeOverlay.querySelector('quick-add-product');
    if (quickAddElement) {
      this.setupQuickAddFunctionality(quickAddElement);
    }
  }

  static setupQuickAddFunctionality(element) {
    const form = element.querySelector('form');
    const variantButtons = element.querySelectorAll('.shoppable-item-variant-selector');
    const variantSelect = element.querySelector('[data-variant-select]');
    const submitButton = element.querySelector('.shoppable-item-atc');
    const hiddenInput = element.querySelector('.product-variant-id');
    const buttonText = submitButton?.querySelector('span');
    const originalButtonText = buttonText?.textContent;

    variantButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        const selectedButton = e.target.closest('.shoppable-item-variant-selector');
        if (!selectedButton || selectedButton.disabled) return;

        const variantId = selectedButton.dataset.variantId;
        hiddenInput.value = variantId;

        variantButtons.forEach(btn => btn.classList.remove('selected'));
        selectedButton.classList.add('selected');

        if (variantSelect) variantSelect.value = variantId;
        // Clear any error state
        ProductCardOverlayManager.clearErrorForElement(element);

        if (submitButton) {
          submitButton.disabled = false;
          if (buttonText) buttonText.textContent = originalButtonText;
        }
      });
    });

    if (variantSelect) {
      variantSelect.addEventListener('change', (e) => {
        const variantId = e.target.value;
        if (!variantId) return;

        hiddenInput.value = variantId;
        variantButtons.forEach(btn => {
          btn.classList.remove('selected');
          if (btn.dataset.variantId === variantId) {
            btn.classList.add('selected');
          }
        });

        // Clear any error state
        ProductCardOverlayManager.clearErrorForElement(element);

        if (submitButton) {
          submitButton.disabled = false;
          if (buttonText) buttonText.textContent = originalButtonText;
        }
      });
    }

    if (form) {
      form.addEventListener('submit', (e) => this.handleFormSubmit(e, submitButton, buttonText, originalButtonText, hiddenInput));
    }
  }

  static async handleFormSubmit(e, submitButton, buttonText, originalButtonText, hiddenInput) {
    e.preventDefault();

    // Check if a variant is selected
    if (!hiddenInput.value || hiddenInput.value === '') {
      const form = e.target;
      const variantContainer = form.querySelector('.shoppable-item-variants');
      const variantSelect = form.querySelector('[data-variant-select]');

      // Add error styling to variant container
      if (variantContainer) {
        variantContainer.classList.add('error');
      }

      // Add error class to select dropdown for mobile
      if (variantSelect) {
        variantSelect.classList.add('error');
      }

      // Show error message
      if (buttonText) buttonText.textContent = 'Please select a size';

      // Remove error styling after 3 seconds
      setTimeout(() => {
        if (variantContainer) {
          variantContainer.classList.remove('error');
        }
        if (variantSelect) {
          variantSelect.classList.remove('error');
        }
        if (buttonText) buttonText.textContent = originalButtonText;
      }, 3000);

      return;
    }

    if (submitButton) {
      submitButton.classList.add('loading');
      submitButton.setAttribute('aria-disabled', true);
      if (buttonText) buttonText.textContent = 'Adding...';
    }

    const formData = new FormData();
    formData.append('id', hiddenInput.value);
    formData.append('quantity', '1');
    formData.append('sections', [
      'cart-notification-product',
      'cart-notification-button',
      'cart-icon-bubble',
      'main-cart-items',
      'main-cart-footer'
    ].join(','));

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    })
    .then(response => response.json())
    .then(async response => {
      if (response.status) {
        console.error('Add to cart error:', response.status);
        return;
      }

      await this.updateCartSections(response, hiddenInput.value);
      this.openMiniCart();
    })
    .catch(console.error)
    .finally(() => {
      if (submitButton) {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        if (buttonText) buttonText.textContent = originalButtonText;
      }
    });
  }

  static async updateCartSections(response, variantId = null) {
    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification) {
      cartNotification.renderContents(response);
    }

    if (response.sections) {
      this.updateSection('main-cart-items', response.sections['main-cart-items']);
      this.updateSection('main-cart-footer', response.sections['main-cart-footer']);
      this.updateCartBubble(response.sections['cart-icon-bubble']);
    }

    // Get fresh cart data and dispatch event - let cart.js handle all updates
    const cartResponse = await fetch('/cart.json');
    const cartData = await cartResponse.json();

    // Dispatch the same event that cart.js listens for
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartData } }));
  }

  static updateSection(sectionId, sectionHtml) {
    const section = document.getElementById(sectionId);
    if (section && sectionHtml) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, 'text/html');
      const newContent = doc.querySelector('.js-contents');
      const currentContent = section.querySelector('.js-contents');
      if (newContent && currentContent) {
        currentContent.innerHTML = newContent.innerHTML;
      }
    }
  }

  static updateCartBubble(bubbleHtml) {
    if (bubbleHtml) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(bubbleHtml, 'text/html');
      const newBubble = doc.querySelector('.cart-count-bubble');
      const currentBubble = document.querySelector('.cart-count-bubble');
      if (newBubble && currentBubble) {
        currentBubble.innerHTML = newBubble.innerHTML;
      }
    }
  }

  static openMiniCart() {
    document.querySelector('body')?.classList.add('overflow-hidden');
    const miniCart = document.querySelector('#mini-cart');
    if (miniCart) {
      miniCart.classList.add('mini-cart--open');
      if (typeof trapFocus === 'function') {
        trapFocus(miniCart, miniCart.querySelector('.mini-cart__close'));
      }
      document.querySelector('.mini-cart-overlay')?.classList.add('mini-cart-overlay--open');
    }
  }

  static attachEventListeners() {
    const handleMouseLeave = () => this.cleanup();
    const handleScroll = () => this.cleanup();
    const handleResize = () => {
      if (!this.isDesktop()) this.cleanup();
    };

    this.activeOverlay.addEventListener('mouseleave', handleMouseLeave, { once: true });
    window.addEventListener('scroll', handleScroll, { once: true, passive: true });
    window.addEventListener('resize', handleResize, { once: true, passive: true });

    // Store handlers for cleanup
    this.activeOverlay._handlers = { handleMouseLeave, handleScroll, handleResize };
  }

  static cleanup() {
    if (!this.activeOverlay) return;

    const handlers = this.activeOverlay._handlers;
    if (handlers) {
      this.activeOverlay.removeEventListener('mouseleave', handlers.handleMouseLeave);
      window.removeEventListener('scroll', handlers.handleScroll);
      window.removeEventListener('resize', handlers.handleResize);
    }

    // Reset parent z-index
    if (this.originalCard && this.originalCard.parentElement) {
      this.originalCard.parentElement.style.zIndex = '';
    }

    // Restore body overflow-x
    document.body.style.overflowX = '';

    // Restore original overflow on .new-product-recommendations
    const productRecommendations = document.querySelector('.new-product-recommendations');
    if (productRecommendations) {
      productRecommendations.style.overflow = this.originalOverflow || '';
    }

    this.activeOverlay.remove();
    this.activeOverlay = null;
    this.originalCard = null;
    this.originalOverflow = null;
  }
}

function handleProductCardHover(card) {
  if (window.innerWidth < 1279) {
    return;
  }

  ProductCardOverlayManager.init(card);
}

document.addEventListener('DOMContentLoaded', () => {
  const productCards = document.querySelectorAll('[data-product-card-hover]');
  productCards.forEach(card => {
    card.addEventListener('mouseenter', function() {
      handleProductCardHover(this);
    });
  });
});

window.handleProductCardHover = handleProductCardHover;

// Override the original function to add error handling
if (typeof window.addRecommendationsToMiniCart === 'undefined') {
  window.addRecommendationsToMiniCart = function(recsContainer, recsCardsContainer, url) {
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        let cardsHTML = '';

        // Add error checking for data.products
        if (!data || !data.products || !Array.isArray(data.products)) {
          console.warn('Product recommendations API returned invalid data:', data);
          return;
        }

        for (const product of data.products) {
          // Original recommendation logic would go here, but since it's complex
          // and in Liquid, we'll just prevent the error for now
          console.log('Processing recommendation for product:', product.title);
        }

        // Update the container if we have cards
        if (cardsHTML && recsCardsContainer) {
          recsCardsContainer.innerHTML = cardsHTML;
        }
      })
      .catch((error) => {
        console.warn('Failed to fetch product recommendations:', error);
      });
  };
}